import {
  __esm,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/utils/compact.ts
var compact;
var init_compact = __esm({
  "src/utils/compact.ts"() {
    compact = (object) => {
      const clone = __spreadValues({}, object);
      for (const key in clone) {
        if (clone[key] === void 0) {
          delete clone[key];
        }
      }
      return clone;
    };
  }
});

export {
  compact,
  init_compact
};
